import { Component, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { QuestionConstant } from 'src/app/constants/label-constants';
import { QuestionModel } from 'src/app/models/questionModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { DeleteDialogboxComponent } from '../../delete-dialogbox/delete-dialogbox.component';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { StatusDialogboxComponent } from '../../status-dialogbox/status-dialogbox.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FileDownloadService } from 'src/app/services/FileDownload.service';
import { UploadQuestionDialogBoxComponent } from '../upload-question-dialog-box/upload-question-dialog-box.component';

@Component({
  selector: 'app-question-list',
  templateUrl: './question-list.component.html',
  styleUrls: ['./question-list.component.scss']
})
export class QuestionListComponent {
  questionForm: FormGroup = this.formBuilder.group({});
  QuestionList: any = [];
  enterSearch: string = '';
  questionTypeIds: any = '';
  searchClose: boolean = false;
  questionSetIds: any = '';
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  showData: boolean = false;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'questionSetName', 'questionTypeText', 'questionText', 'optionCount', 'isActive', 'Action'];
  dataSource: MatTableDataSource<QuestionModel> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  CommonConstant: any = [];
  NoRecordFound: any = [];
  QuestionConstant: any = [];
  questionStatusObj: any = {};
  questionDeleteObj: any = {};
  paragraphDeleteObj: any = {};
  questionTypeList: any = [];
  questionSetList: any = [];

  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.questionForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }
  dropdownQuestionTypeSettings: IDropdownSettings = {};
  dropdownQuestionSetSettings: IDropdownSettings = {};
  selectedQuestionTypeItems: any = [];
  selectedQuestionSetItems: any = [];

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private formBuilder: FormBuilder,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private router: Router,
    private EncrDecr: EncrDecrService,
    private modalService: NgbModal,
    private toster: ToastrService,
    private fileDownloadService: FileDownloadService
  ) { }

  async ngOnInit(): Promise<void> {
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.QuestionConstant = QuestionConstant;
    this.sharedService.setData('Questions');
    await this.getQuestionTypeList();
    await this.getQuestionSetList();
    this.dropdownQuestionTypeSettings = {
      idField: 'questionTypeId',
      textField: 'questionTypeText',
      singleSelection: false,
      enableCheckAll: true,
      allowSearchFilter: true,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search Question Type',
      showSelectedItemsAtTop: false,
    };
    this.dropdownQuestionSetSettings = {
      idField: 'questionSetId',
      textField: 'questionSetName',
      singleSelection: false,
      enableCheckAll: true,
      allowSearchFilter: true,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search Question Set Type',
      showSelectedItemsAtTop: false,
    }
    await this.getQuestionList();
  }

  resetGrid(){
    this.enterSearch = "";
    this.selectedQuestionTypeItems = [];
    this.selectedQuestionSetItems = [];
    this.questionSetIds = [];
    this.questionTypeIds = [];
    this.searchClose = false;
    this.getQuestionList();
  }

  async getQuestionList() {
    this.showData = false;
    const questionTypeArray = this.selectedQuestionTypeItems.filter(f => f.questionTypeId != 0).map(({ questionTypeId }) => questionTypeId);
    const questionSetArray = this.selectedQuestionSetItems.filter(f => f.questionSetId != 0).map(({ questionSetId }) => questionSetId);
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection,
      QuestionTypeIds: questionTypeArray ? questionTypeArray.toString() : '',
      QuestionSetIds: questionSetArray ? questionSetArray.toString() : ''
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetQuestionList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.QuestionList = response.data
          this.dataSource.data = this.QuestionList;
          if (this.QuestionList.length > 0) {
            TotalRecords = this.QuestionList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        this.toster.error(error.message);
      }
    });
  }

  //Get question types
  async getQuestionTypeList() {
    const apiUrl = this.apiUrl.apiUrl.question.GetQuestionTypes;
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          this.questionTypeList = data.data;
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  //Get Question Set type
  async getQuestionSetList() {
    const apiUrl = this.apiUrl.apiUrl.test.GetQuestionSetListWithOutCount;
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          this.questionSetList = data.data;
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  onSelectAllQuestionType(item: any) {
    this.selectedQuestionTypeItems = [];
    item.forEach((element, index) => {
      this.selectedQuestionTypeItems.push(element);
    });
    this.getQuestionList();
  }

  onSelectAllQuestionSet(item: any) {
    this.selectedQuestionSetItems = [];
    item.forEach((element, index) => {
      this.selectedQuestionSetItems.push(element);
    });
    this.getQuestionList();
  }

  onItemSelectQuestionType(item: any) {
    this.selectedQuestionTypeItems.push(item);
    this.getQuestionList();
  }

  onItemSelectQuestionSet(item: any) {
    this.selectedQuestionSetItems.push(item);
    this.getQuestionList();
  }

  onItemDeSelectQuestionType(item: any) {
    this.selectedQuestionTypeItems.forEach((element, index) => {
      if (element.questionTypeId == item.questionTypeId)
        this.selectedQuestionTypeItems.splice(index, 1);
    });
    this.getQuestionList();
  }

  onItemDeSelectQuestionSet(item: any) {
    this.selectedQuestionSetItems.forEach((element, index) => {
      if (element.questionSetId == item.questionSetId)
        this.selectedQuestionSetItems.splice(index, 1);
    });
    this.getQuestionList();
  }

  onUnSelectAllQuestionType() {
    this.selectedQuestionSetItems = [];
    this.getQuestionList();
  }

  onUnSelectAllQuestionSet() {
    this.selectedQuestionSetItems = [];
    this.getQuestionList();
  }

  pageChanged(event: { pageSize: number; pageIndex: number; }) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getQuestionList();
  }

  SortChange(event: { direction: string; active: any; }) {
    this.sortDirection = event.direction == '' ? 'asc' : event.direction;
    this.SortColumn = event.active;
    this.getQuestionList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getQuestionList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value.trim();
      this.getQuestionList();
      this.searchClose = true;
    }
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getQuestionList();
    this.searchClose = false;
  }

  sanitizeInput(event: any) {
    const inputElement: HTMLInputElement = event.target;
    const sanitizedValue: string = inputElement.value.replace(/\D/g, '');
    inputElement.value = sanitizedValue;
  }

  onEdit(questionId: number, questionTypeText: string) {
    if (questionId > 0) {
      var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', questionId);
      this.router.navigate(['question/edit', questionTypeText.replace(' ', '').toLowerCase(), encrypted]);
    }
    else {
      this.router.navigate(['question/add'])
    }
  }

  onParagraphEdit(paragraphId: number, questionTypeText: string) {
    if (paragraphId > 0) {
      var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', paragraphId);
      this.router.navigate(['question/edit', questionTypeText.replace(' ', '').toLowerCase(), encrypted]);
    }
    else {
      this.router.navigate(['question/add'])
    }
  }

  onView(questionId: number, questionTypeText: string) {
    var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', questionId);
    this.router.navigate(['question/view', questionTypeText.replace(' ', '').toLowerCase(), encrypted]);
  }

  Deletepopup(questionId: number, questionText: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.questionDeleteObj = {
      questionId: questionId,
      questionText: questionText,
      element: 'question'
    }
    modalRef.componentInstance.questionDeleteObj = this.questionDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        if (this.QuestionList.length == 1 && this.currentPage != 0) {
          this.currentPage -= 1;
        }
        this.getQuestionList();
      }
    }).catch((error) => {
    });
  }

  DeleteParagraphpopup(paragraphId: number, paragraphText: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.paragraphDeleteObj = {
      paragraphId: paragraphId,
      paragraphText: '',
      element: 'paragraph'
    }
    modalRef.componentInstance.paragraphDeleteObj = this.paragraphDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        if (this.QuestionList.length == 1 && this.currentPage != 0) {
          this.currentPage -= 1;
        }
        this.getQuestionList();
      }
    }).catch((error) => {
    });
  }

  onStatus(questionId: number, questionText: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.questionStatusObj = {
      questionId: questionId,
      questionText: questionText,
      activeQuestion: active
    }
    modalRef.componentInstance.questionStatusObj = this.questionStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.QuestionList.forEach((element: { questionId: number; isActive: boolean; }) => {
          if (element.questionId == questionId) {
            element.isActive = active ? false : true
          }
        });
      }
    }).catch((error) => {
    });
  }
  Upload() {
    const modalRef = this.modalService.open(UploadQuestionDialogBoxComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getQuestionTypeList();
        this.getQuestionSetList();
        this.getQuestionList();
      }
    }).catch((error) => {
    });
  }
  DownloadFile() {
    this.spinner.show();
    this.fileDownloadService.downloadQuestionExcelFile();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
  }
}
